// extracted by mini-css-extract-plugin
module.exports = {"comingSoonContainer":"index_comingSoonContainer__W0d0P","icon":"index_icon__UhVCC"};